// Enum of all possible func values
export enum PlotFunction {
  PLOT_MEDIA = "plot_media",
  PLOT_PATH = "plot_path",
  PLOT_RECT = "plot_rect",
  PLOT_TEXT = "plot_text",
}
